module.exports = __webpack_public_path__ + "img/top.fa94cab6.svg";